import { z } from 'zod';

import { zodListParsingCasesParamsSchema } from '~/data/deliveryNote/useQueryParsingCases';

// A bare id in the URL parses as a one-element list.
const zodIdListSearchSchema = z
  .array(z.uuid())
  .or(z.uuid().transform((id) => [id]))
  .optional();

export const zodScansOrderBySchema = z
  .enum(['createdOn', 'deliveryNoteDate', 'deliveryNoteId', 'status'])
  .default('createdOn')
  .catch('createdOn');

export const zodScansSearchSchema = zodListParsingCasesParamsSchema
  .omit({
    offset: true,
    returnTotalCount: true,
  })
  .extend({
    accountingReferenceId: zodIdListSearchSchema,
    orderBy: zodScansOrderBySchema,
    page: z.number().int().min(0).default(0).catch(0),
    savedFilterId: z.uuid().optional().catch(undefined),
    siteId: zodIdListSearchSchema,
  });

export const scansSearchDefaults = zodScansSearchSchema.parse({});
